'use client'

import React, { useEffect, useState } from 'react'

import { JoinUsNowModal } from 'Components/Blocks/Modals'
import { BlogPostHeroSection, RelatedBlogsSection } from 'Components/Sections'
import BlogPostBodySection from 'Components/Sections/BlogPostBody'
import { Column } from 'Components/UI'
import { NewsItem } from 'Types/emajinAPI'

function BlogPostPage() {
  const [blogPost, setBlogPost] = useState<NewsItem | undefined>(undefined)
  const [joinUsModalModalOpened, setJoinUsModalModalOpened] = useState(false)

  useEffect(() => {
    const raw = sessionStorage.getItem('blogPost')
    if (raw) {
      const parsed = JSON.parse(raw)

      setBlogPost(parsed)
    }
  }, [])

  if (!blogPost) return null

  return (
    <Column alignCenter fullWidth gap={[10, 10, 10, 16]}>
      <BlogPostHeroSection
        data={blogPost}
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <BlogPostBodySection data={blogPost} />

      <RelatedBlogsSection />

      <JoinUsNowModal
        isOpened={joinUsModalModalOpened}
        onClose={() => setJoinUsModalModalOpened(false)}
      />
    </Column>
  )
}

export default BlogPostPage
